export const handleNoSession = (e, onApiFail) => {
    if ((e.status === 401) && (onApiFail)) {
        onApiFail();
    }
}
